export const getMapLayerFilter = (zoom, hideIds = [], type) => {
  const baseFilter = ["all", ["<=", "minzoom", zoom], ["!in", "id", ...hideIds]];

  if (!type) {
    return baseFilter;
  }
  return [...baseFilter, ["==", "$type", type]];
};
